import { render } from "./CountryBoxes.vue?vue&type=template&id=8937e1f0"
import script from "./CountryBoxes.vue?vue&type=script&lang=js"
export * from "./CountryBoxes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__